import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { AldVisitFormBaseComponent } from '../../../../../../src/app/shared/components/form/ald-visit-form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";
import { BannerService } from '../../../../../../src/app/shared/services/banner.service';

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import { User } from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';

import * as TyreOrderModels from '../../../../../../src/app/models/tyre-order/tyre-order';
import { AldState } from "../../../../../../src/app/services/ald/ald.state";
import * as AldActions from "../../../../../../src/app/services/ald/ald.action";


import * as GarageVisitsModels from '../../../../../../src/app/models/garage-visits/garage-visits';
import * as GarageVisitsAction from '../../../../../../src/app/services/garage-visits/garage-visits.action';
import { GarageVisitsState } from '../../../../../../src/app/services/garage-visits/garage-visits.state';
import * as GarageModels from '../../../../../../src/app/models/garage/garage';
import * as CarModels from "../../../../../../src/app/models/car/car";

@Component({
    selector: 'app-tyre-order-visit',
  templateUrl: './tyre-order-visit.component.html',
  styleUrls: ['./tyre-order-visit.component.scss']
})

export class TyreOrderVisitComponent extends AldVisitFormBaseComponent implements OnInit {

  public formMain: FormGroup;

  public tyreOrder: TyreOrderModels.TyreOrderModel;

  private tyreOrderId: number;


  get inputFirstName(): any {
    return this.formMain.get('inputFirstName');
  }

  get inputLastName(): any {
    return this.formMain.get('inputLastName');
  }

  get inputPhoneNr(): any {
    return this.formMain.get('inputPhoneNr');
  }

  get inputMail(): any {
    return this.formMain.get('inputMail');
  }


  @Select(AldState.TyreOrder)
  TyreOrder$: Observable<Models.Response<TyreOrderModels.TyreOrderModel>>;

  constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef,
        public activatedRoute: ActivatedRoute,
        public bannerService: BannerService
    ) {

    super(helperService, environmentService, changeDetectorRef, router, authenticationService, store, bannerService);

      this.garageVisitsSearch.IsPagination = false;

      this.garageVisitsPlaceSearch.IsPagination = false;

      this.garageVisitsPlaceSearch.IsActive = true;
    }

  ngOnInit() {

    super.ngOnInit();

    this.formMain = this.formBuilder.group({
      inputFirstName: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(3)]],
      inputLastName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      inputPhoneNr: ['', Validators.required],
      inputMail: ['', Validators.required]
    });

    this.subscription.add(this.TyreOrder$.subscribe((data) => {

      if (data && data.Success) {

        this.tyreOrder = data.Item;

        this.currentGarage = this.tyreOrder.GarageTo;

        this.now.setDate(this.now.getDate() + this.currentGarage.CustomerVisitDelayDays);

        this.getGarageVisits(this.currentDate);

        this.getGarageVisitsPlace();

        this.getGarageBlockedDays();

        }
    }));
  }

  public onUserAuthenitcate() {

    if (this.currentUser && this.currentUser.CarId) {

      this.activatedRoute.paramMap.subscribe(params => {

        this.tyreOrderId = +params.get('id');

        if (this.tyreOrderId) {

          this.requestGetTyreOrder = new Models.RequestModel(this.tyreOrderId);

          this.store.dispatch(new AldActions.TyreOrderGet(this.requestGetTyreOrder));
        }
      });

      this.requestGetCar = new Models.RequestModel(this.currentUser.CarId);

      this.store.dispatch(new AldActions.CarGet(this.requestGetCar));
    }
  };

  public IsFormValid(): boolean {
    return this.IsEmailValid && this.IsTelephoneValid && this.formMain.valid;
  }



  public onSaveNewVisit() {

    this.newGarageVisit.VisitTyreSourceId = GarageVisitsModels.VisitTyreSourceType.TyreOrder;
    this.newGarageVisit.TyreId = null;
    this.newGarageVisit.TyreName = null;
    this.newGarageVisit.TyreFromOrderId = this.tyreOrder.OrderId;
    this.newGarageVisit.TyreFromDepositeId = null;
    this.newGarageVisit.GarageId = this.tyreOrder.GarageTo.GarageId;

    this.requestGarageVisitSave.Begin();
    this.requestGarageVisitSave.Context = this.car;
    this.requestGarageVisitSave.Item = this.newGarageVisit;


    this.store.dispatch(new AldActions.GarageVisitCreate(this.requestGarageVisitSave));
  }

  public onSummary() { }
}
